var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowUpBrucke(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1279 22.6587L10.8574 22.6587L10.8574 9.12353C10.8574 8.70361 10.7109 8.34717 10.418 8.0542C10.125 7.76123 9.76855 7.61474 9.34863 7.61474C8.93848 7.61474 8.5918 7.75635 8.30859 8.03955L4.5 11.8481L4.5 8.84521L12 1.34521L19.5 8.84521L19.5 11.8481L15.6768 8.03955C15.3936 7.75635 15.0469 7.61474 14.6367 7.61474C14.2168 7.61474 13.8604 7.76123 13.5674 8.0542C13.2744 8.34717 13.1279 8.70361 13.1279 9.12353L13.1279 22.6587Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUpBrucke);
export default __webpack_public_path__ + "static/media/arrow-up-brucke.0cbdabb05e9143f52c7104b8757aadda.svg";
export { ForwardRef as ReactComponent };